import { useInfiniteQuery } from "@tanstack/react-query";
import { SearchUsersResponse, searchUsers } from "../services/search.service";
import { userKeys } from "../queryKeys";
import { User } from "../../../../types/types";
import { searchUsersParams } from "../types/search.types";
import { formatSearchUsersFormatter } from "../formatters/formatSearchUsersFormatter";

export const useInfiniteSearchUsers = (params: searchUsersParams) => {
  const formattedParams = formatSearchUsersFormatter(params);

  return useInfiniteQuery<SearchUsersResponse, Error, User[], (string | Record<string, any>)[], number>({
    queryKey: [...userKeys.search(params), "infinite"],
    queryFn: () => searchUsers(formattedParams),
    initialPageParam: 0,
    getNextPageParam: (lastPage, allPages) => {
      const totalFetched = allPages.length * (params.limit ?? 12);
      return totalFetched < lastPage.total ? allPages.length : undefined;
    },
    staleTime: 1000 * 60 * 5,
    select: (data) => data.pages.flatMap((page) => page.items),
  });
};
